export async function copyToClipboard(text: string): Promise<boolean>
{
    try
    {
        await navigator.clipboard.writeText(text);
        return true;
    }
    catch
    {
        return legacyCopy(text);
    }
}

/**
 * Fallback copy: selects the text in a hidden, temporary textarea and runs execCommand('copy').
 * The textarea is always removed again.
 */
function legacyCopy(text: string): boolean
{
    const textarea = document.createElement('textarea');
    
    try
    {
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        
        // Deprecated, but still the only fallback when the async Clipboard API is blocked
        return document.execCommand('copy');
    }
    catch
    {
        return false;
    }
    finally
    {
        textarea.remove();
    }
}